import React, { useState } from 'react'
import { Col, Container, Row, Table, Modal } from 'react-bootstrap'
import { Table as BootstrapTable, Offcanvas } from 'react-bootstrap';
import { FaShoppingCart, FaDownload, FaCheckCircle } from "react-icons/fa";
import { Forms, DropDowns } from '../../components/Forms';
import { Buttons, Close } from '../../components/Buttons/Buttons';
import PageTitle from '../../components/Buttons/PageTitle';
import { FaPlay, FaTimes } from "react-icons/fa";
import { PDFDownloadLink } from '@react-pdf/renderer';
import '../cardfour/CardFour.css'
import Bill from '../../pdf/Bill';
import { ToastContainer, toast } from 'react-toastify';
import { AiTwotonePicture } from "react-icons/ai";
import { MdOutlineVideoLibrary } from "react-icons/md";
import 'react-toastify/dist/ReactToastify.css';
import API_DOMAIN from '../../config/config';

const CardFour = ({ products, category, selectedProduct, totals, addToCart, setShowVideoModal, showVideoModal, updateQuantity, handleShowCart, handleCloseCart, showCart, handleClose, handleShow, show, removeProduct, cart, districtData, companydata, setCart, setting, banner, handleQuantityChange }) => {
    const [checkout, setCheckOut] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submittedOrder, setSubmittedOrder] = useState(null);

    const closeOut = () => {
        if (!isSubmitting) {
            setCheckOut(false);
        }
    };
    const showOut = () => setCheckOut(true);

    const [showEstimate, setShowEstimate] = useState(false);
    const closeModal = () => {
        setShowEstimate(false);
        window.location.reload();
    };
    const showModal = () => setShowEstimate(true);

    const [formData, setFormData] = useState({
        state: '',
        city: '',
        name: '',
        email: '',
        mobile: '',
        address: ''
    });
    const [cityOptions, setCityOptions] = useState([]);
    const [printData, setPrintData] = useState([]);

    const handleStateChange = (selectedOption) => {
        const state = selectedOption.value;
        setFormData(prevState => ({
            ...prevState,
            state,
            city: ''
        }));

        const cities = districtData[state] || [];
        setCityOptions(cities.map(city => ({ value: city, label: city })));
    };

    const handleCityChange = (selectedOption) => {
        const city = selectedOption.value;
        setFormData(prevState => ({
            ...prevState,
            city
        }));
    };

    const handleChange = (e, fieldName) => {
        const value = e.target ? e.target.value : e.value;
        setFormData({
            ...formData,
            [fieldName]: value
        });
    };

    const handleSubmit = () => {
        if (isSubmitting) return;

        if (!cart || cart.length === 0) {
            toast.warning('Your cart is empty! Please add crackers first.', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
            return;
        }

        if (!formData.name || formData.name.trim() === '') {
            toast.error('Please enter your Name!', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
            return;
        }

        if (!formData.mobile || formData.mobile.trim() === '') {
            toast.error('Please enter your Mobile Number!', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
            return;
        }

        const phoneDigits = formData.mobile.replace(/\D/g, '');
        if (phoneDigits.length < 10) {
            toast.error('Please enter a valid 10-digit Mobile Number!', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });
            return;
        }

        setIsSubmitting(true);

        const payload = {
            "cart_pro": cart,
            "customer_data": formData,
            "total_products": totals.totalProducts,
            "total_price": totals.discountRate.toFixed(2),
            "total_discount": totals.overallTotal.toFixed(2)
        };

        fetch(`${API_DOMAIN}/online_enq_web.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                setIsSubmitting(false);
                if (data.head && data.head.code === 200) {
                    const orderData = data.body.data || {};
                    if (!orderData.customer) {
                        orderData.customer = {
                            name: formData.name,
                            email: formData.email,
                            mobile: formData.mobile,
                            address: formData.address,
                            city: formData.city,
                            state: formData.state
                        };
                    }
                    setPrintData(orderData);
                    setSubmittedOrder({
                        enq: orderData.enq || `ENQ-${Math.floor(100000 + Math.random() * 900000)}`,
                        customer: { ...formData },
                        totals: {
                            totalProducts: totals.totalProducts,
                            overallTotal: totals.overallTotal,
                            discountedOverallTotal: totals.discountedOverallTotal,
                            discountRate: totals.discountRate
                        }
                    });
                    toast.success('🎉 Estimate submitted successfully!', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored",
                    });
                    showModal();
                    setCart([]);
                    setFormData({
                        state: '',
                        city: '',
                        name: '',
                        email: '',
                        mobile: '',
                        address: ''
                    });
                    closeOut();
                } else {
                    const msg = (data.body && data.body.msg) || 'Failed to submit estimate. Please try again.';
                    toast.error(msg, {
                        position: "top-center",
                        autoClose: 3000,
                        theme: "colored",
                    });
                    console.error('API Error:', msg);
                }
            })
            .catch(error => {
                setIsSubmitting(false);
                toast.error('Network error. Please check your connection and try again!', {
                    position: "top-center",
                    autoClose: 3000,
                    theme: "colored",
                });
                console.error('Error submitting enquiry:', error);
            });
    };

    const extractVideoId = (url) => {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be') {
            return urlObj.pathname.slice(1);
        } else if (urlObj.hostname === 'youtube.com' || urlObj.hostname === 'www.youtube.com') {
            return urlObj.searchParams.get('v') || urlObj.pathname.split('/').pop();
        }
        return '';
    };
    const handleVideoModalShow = () => {
        console.log('Showing video modal');
        setShowVideoModal(true);
    };

    const handleVideoModalClose = () => {
        console.log('Closing video modal');
        setShowVideoModal(false);
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg='12'>
                        <Row>
                            <Col lg='12' className='px-0'>
                                <div className='w-100 table-four-pricelist stick-top'>
                                    <div className='d-flex align-items-center justify-content-between flex-wrap gap-2 px-1 px-md-3'>
                                        <div className='d-flex align-items-center gap-2 flex-wrap'>
                                            <div className='summary-pill'>
                                                <span>📦 Products:</span>
                                                <strong>{totals.totalProducts}</strong>
                                            </div>
                                            <div className='summary-pill d-none d-sm-inline-flex'>
                                                <span>MRP Total:</span>
                                                <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹{totals.overallTotal.toFixed(2)}</span>
                                            </div>
                                            <div className='summary-pill-highlight'>
                                                <span>Payable: ₹{totals.discountRate.toFixed(2)}</span>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center'>
                                            <button 
                                                type='button'
                                                className='btn btn-warning d-flex align-items-center gap-2 fw-bold text-dark px-3 py-1 rounded-pill shadow-sm'
                                                onClick={handleShowCart}
                                                style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', border: 'none' }}
                                            >
                                                <FaShoppingCart size={18} />
                                                <span>Cart ({cart.length})</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <Table className='mb-0 fourth-table' responsive>
                                        <thead>
                                            <tr className='cardfour-table'>
                                                <th className='col-preview'>
                                                    <span className='d-none d-sm-inline'>Preview</span>
                                                    <span className='d-inline d-sm-none'>View</span>
                                                </th>
                                                <th className='col-product'>Product Name</th>
                                                <th className='hide-small col-content'>Content</th>
                                                <th className='col-mrp'>MRP</th>
                                                <th className='col-rate'>
                                                    <span className='d-none d-sm-inline'>Offer Price</span>
                                                    <span className='d-inline d-sm-none'>Rate</span>
                                                </th>
                                                <th className='col-qty'>
                                                    <span className='d-none d-sm-inline'>Quantity</span>
                                                    <span className='d-inline d-sm-none'>Qty</span>
                                                </th>
                                                <th className='col-total'>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {category.map((categoryItem) => (
                                                <React.Fragment key={categoryItem.id}>
                                                    <tr>
                                                        <th colSpan={7} className='category-bg text-center'>
                                                            <div className='category'>
                                                                <span className='category-name'>✨ {categoryItem.category_name}</span>
                                                                {categoryItem.discount > 0 && (
                                                                    <span className='discount_percentage'>
                                                                        🏷️ {categoryItem.discount}% FLAT DISCOUNT
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </th>
                                                    </tr>

                                                    {products
                                                        .filter((product) => product.category_id === categoryItem.id)
                                                        .map((product) => (
                                                            <tr className='product-four-list' key={product.id}>
                                                                <td className='col-preview'>
                                                                    <div onClick={() => handleShow(product)} className="d-flex justify-content-center align-items-center preview-wrapper">
                                                                        <span className="media-icon-chip" title="View Photo">  <AiTwotonePicture size={18} /></span>
                                                                        <span className="media-icon-chip" title="Watch Video"> <MdOutlineVideoLibrary size={18} /></span>
                                                                    </div>
                                                                </td>

                                                                <td className='col-product'>
                                                                    <div className='cardfour-product-name'>{product.product_name}</div>
                                                                    {product.product_content && (
                                                                        <div className='product-mobile-content d-lg-none'>{product.product_content}</div>
                                                                    )}
                                                                </td>

                                                                <td className='hide-small col-content'>
                                                                    <div className='text-muted small'>{product.product_content}</div>
                                                                </td>

                                                                <td className='col-mrp'>
                                                                    <div className='netrate'>
                                                                        ₹{product.price}
                                                                    </div>
                                                                </td>

                                                                <td className='col-rate'>
                                                                    <div className='offer-rate'>
                                                                        ₹{product.discount_lock !== null && product.discount_lock === 0
                                                                            ? Math.round(product.price - (product.price * categoryItem.discount) / 100)
                                                                            : Math.round(product.price)}
                                                                    </div>
                                                                </td>

                                                                <td className='col-qty'>
                                                                    <div>
                                                                        <input
                                                                            className='card-four-table-input-qty form-control'
                                                                            type='number'
                                                                            value={products.find(products => products.id === product.id)?.qty || ''} 
                                                                            min='0'
                                                                            placeholder='0'
                                                                            onChange={(e) => handleQuantityChange(product.id, e.target.value,categoryItem.discount)}
                                                                        />
                                                                    </div>
                                                                </td>

                                                                <td className='col-total'>
                                                                    <div>
                                                                        <input
                                                                            className='card-four-table-input-price form-control'
                                                                            value={
                                                                                Math.round(
                                                                                    (product.discount_lock !== null && product.discount_lock === 0
                                                                                        ? Math.round(product.price - (product.price * categoryItem.discount) / 100)
                                                                                        : Math.round(product.price)) * (product.qty || 0)
                                                                                )
                                                                            }
                                                                            readOnly
                                                                        />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </Table>

                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <>
                <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title><div> {selectedProduct && selectedProduct.product_name}</div></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table>
                            <tbody>
                                <tr>
                                    <td class="text-center image_video" colspan="2">
                                        <div className='modal-img mx-auto'>
                                            {selectedProduct && (
                                                selectedProduct.img ? (
                                                    <img src={selectedProduct.img} className='img-fluid' alt='Product' />
                                                ) : (
                                                    <img src={require('../../assets/images/storelogo.png')} className='img-fluid' alt='product' />
                                                )
                                            )}
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer className='mx-auto'>
                        <table>
                            <tbody>
                                <tr>
                                    {selectedProduct && selectedProduct.img && (
                                        <td>
                                            <div className='dual'>
                                                <img src={selectedProduct.img} className='img-fluid' alt='product' />
                                            </div>
                                        </td>
                                    )}
                                    {selectedProduct && selectedProduct.video_url && (
                                        <td>
                                            <div className='w-25 mx-auto'>
                                                <div className='play-icon' onClick={handleVideoModalShow}>
                                                    <FaPlay />
                                                </div>
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Footer>
                </Modal>
                {showVideoModal && (
                    <Modal show={showVideoModal} onHide={handleVideoModalClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{selectedProduct && selectedProduct.product_name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <iframe
                                width="100%"
                                height="400"
                                src={`https://www.youtube.com/embed/${extractVideoId(selectedProduct.video_url)}`}
                                frameBorder="0"
                                allowFullScreen
                                title="Product Video"
                            />
                        </Modal.Body>
                    </Modal>
                )}
            </>
            <>
                <Offcanvas show={showCart} onHide={handleCloseCart} scroll="true" placement='end'>
                    <PageTitle onClick={handleCloseCart} title={companydata.company_name} address={companydata.address} phone={companydata.phone} />
                    <Offcanvas.Body>
                        <div className='canvas-table'>
                            <div className='cart-table'>
                                <BootstrapTable>
                                    <tbody>
                                        {cart.map(cart => (
                                            <tr key={cart.id}>
                                                <td className='w-75'>
                                                    <div className='product-name pb-2'>{cart.product_name}</div>
                                                    <div className='qty-box'>
                                                        <input className='form-cntrl form-control' value={cart.qty} readOnly />
                                                    </div>
                                                </td>
                                                <td className='text-end'>
                                                    <div className='pb-2'> <Close label={<><FaTimes /></>} onClick={() => removeProduct(cart.id)} /> </div>
                                                    <div className='price_total'>₹<span>{Math.round(cart.total_price)}</span></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </BootstrapTable>
                            </div>
                        </div>
                        <div className='bottom-table'>
                            <BootstrapTable>
                                <tr>
                                    <td>
                                        <tr>
                                            <td className='w-100'>Total MRP rate :</td>
                                            <td> ₹<span>{totals.overallTotal.toFixed(2)}</span></td>
                                        </tr>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <tr>
                                            <td className='w-100'>Total Savings / Discount :</td>
                                            <td> ₹<span>{(totals.discountedOverallTotal).toFixed(2)}</span></td>
                                        </tr>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <tr>
                                            <td className='w-100'>Total Amount :</td>
                                            <td> ₹<span>{(totals.discountRate).toFixed(2)}</span></td>
                                        </tr>
                                    </td>
                                </tr>
                            </BootstrapTable>
                        </div>

                        <div className='text-center'>
                            {/* {totals.discountRate >= "2500" && ( */}
                                <div className='text-center regular py-3'>
                                    <Buttons label={<>Confirm Estimate</>} fullWidth={'100%'}
                                        onClick={() => {
                                            showOut();
                                            handleCloseCart();
                                        }}
                                    ></Buttons>
                                </div>
                            {/* )} */}
                            {/* <div className='py-2'>
                                Min Order : ₹<span>2500</span>
                            </div> */}
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
            </>
            <>
                <Offcanvas show={checkout} onHide={closeOut} scroll="true" placement='end'>
                    <PageTitle onClick={closeOut} title={companydata.company_name} />
                    <Offcanvas.Body>
                        <div className='customer-details'>
                            <div className='canvas-table'>
                                <Container>
                                    <Row>
                                        <Col lg='12' className='py-2'>
                      <DropDowns
                        options={Object.keys(districtData).map(state => ({ value: state, label: state }))}
                        placeholder={"Select State"}
                        label={"Select State"}
                        name="state"
                        value={{ value: formData.state, label: formData.state }}
                        onChange={handleStateChange}
                      />
                    </Col>                                        <Col lg='12' className='py-2'>
                      <DropDowns
                        options={cityOptions}
                        placeholder={"Select City"}
                        label={"Select City"}
                        name="city"
                        value={{ value: formData.city, label: formData.city }}
                        onChange={handleCityChange}
                      />
                    </Col>
                                        <Col lg='12' className='py-2'>
                                            <Forms
                                                placeholder={"Enter your Name"}
                                                label={"Full Name *"}
                                                name="name"
                                                value={formData.name}
                                                onChange={(e) => handleChange(e, 'name')}
                                            />
                                        </Col>
                                        <Col lg='12' className='py-2'>
                                            <Forms
                                                placeholder={"Enter your Mobile No."}
                                                label={"Mobile Number *"}
                                                name="mobile"
                                                value={formData.mobile}
                                                onChange={(e) => handleChange(e, 'mobile')}
                                            />
                                        </Col>
                                        <Col lg='12' className='py-2'>
                                            <Forms
                                                placeholder={"Enter your Email (Optional)"}
                                                label={"Email Address"}
                                                name="email"
                                                value={formData.email}
                                                onChange={(e) => handleChange(e, 'email')}
                                            />
                                        </Col>
                                        <Col lg='12' className='py-2'>
                                            <div className='py-1 fw-bold text-dark small'>
                                                <label>Delivery Address</label>
                                            </div>
                                            <textarea
                                                placeholder='Enter complete address for delivery quotation...'
                                                className='form-control w-100'
                                                rows={3}
                                                name="address"
                                                value={formData.address}
                                                onChange={(e) => handleChange(e, 'address')}
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                            <div className='bottom-table'>
                                <BootstrapTable>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <span className='text-muted'>Total MRP Rate:</span>
                                                    <span className='fw-bold text-secondary text-decoration-line-through'>₹{totals.overallTotal.toFixed(2)}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <span className='text-success fw-bold'>Total Festive Savings:</span>
                                                    <span className='text-success fw-bold'>- ₹{(totals.discountedOverallTotal).toFixed(2)}</span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className='d-flex justify-content-between align-items-center pt-1 border-top'>
                                                    <span className='fw-bold text-dark fs-6'>Estimated Payable:</span>
                                                    <span className='fw-bolder text-danger fs-5'>₹{(totals.discountRate).toFixed(2)}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </BootstrapTable>
                            </div>

                            <div className='checkout-action-area px-3 pb-4 pt-2'>
                                {isSubmitting && (
                                    <div className='submit-loading-status mb-3 p-3 rounded-3 text-center'>
                                        <div className='spinner-border text-danger mb-2' style={{ width: '2rem', height: '2rem' }} role='status'>
                                            <span className='visually-hidden'>Loading...</span>
                                        </div>
                                        <div className='fw-bold text-dark' style={{ fontFamily: 'Outfit, sans-serif', fontSize: '15px' }}>
                                            Submitting Your Estimate...
                                        </div>
                                        <div className='text-muted small'>
                                            Calculating best festive discounts & generating enquiry bill.
                                        </div>
                                    </div>
                                )}

                                <div className='d-flex justify-content-evenly gap-2'>
                                    <div className='text-center w-100'>
                                        <Buttons
                                            label={
                                                isSubmitting ? (
                                                    <span className='d-inline-flex align-items-center justify-content-center gap-2'>
                                                        <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                                                        <span>Submitting...</span>
                                                    </span>
                                                ) : (
                                                    <span className='d-inline-flex align-items-center justify-content-center gap-2'>
                                                        <span>Submit Estimate</span>
                                                    </span>
                                                )
                                            }
                                            className="w-100"
                                            fullWidth={"100%"}
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <div className='text-center w-100'>
                                        <Buttons
                                            label={<>Cancel</>}
                                            fullWidth={"100%"}
                                            onClick={closeOut}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
                <>
                    <Modal
                        show={showEstimate}
                        onHide={closeModal}
                        centered
                        size='lg'
                        backdrop="static"
                        className='estimate-modal-wrapper'
                    >
                        <Modal.Header closeButton className='estimate-modal-header'>
                            <Modal.Title className='d-flex align-items-center gap-2'>
                                <FaCheckCircle className='text-success' size={24} />
                                <span className='fw-bold text-white'>Estimate Confirmation</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='p-3 p-md-4'>
                            {/* Success Banner */}
                            <div className='estimate-success-hero text-center p-3 mb-3 rounded-4'>
                                <div className='success-emoji mb-2'>🎉✨</div>
                                <h4 className='fw-bold text-dark mb-1'>Estimate Submitted Successfully!</h4>
                                <p className='text-muted small mb-2'>
                                    Thank you for placing your order estimate with <strong>{companydata.company_name || 'Alagar Crackers'}</strong>.
                                </p>
                                <div className='d-inline-flex align-items-center gap-2 bg-white px-3 py-1 rounded-pill shadow-sm border'>
                                    <span className='text-muted small'>Enquiry Ref:</span>
                                    <span className='fw-bold text-danger'>#{printData?.enq || submittedOrder?.enq || 'ENQ-CONFIRMED'}</span>
                                </div>
                            </div>

                            <Row className='g-3 mb-3'>
                                {/* Customer Details Box */}
                                <Col md={6}>
                                    <div className='estimate-info-card p-3 rounded-3 h-100 border'>
                                        <h6 className='fw-bold text-dark d-flex align-items-center gap-2 mb-2 pb-1 border-bottom'>
                                            <span>👤 Customer Details</span>
                                        </h6>
                                        <div className='small lh-base'>
                                            <div className='mb-1'><strong>Name:</strong> {submittedOrder?.customer?.name || printData?.customer?.name || '-'}</div>
                                            <div className='mb-1'><strong>Phone:</strong> {submittedOrder?.customer?.mobile || printData?.customer?.mobile || '-'}</div>
                                            {(submittedOrder?.customer?.city || printData?.customer?.city) && (
                                                <div className='mb-1'><strong>City/State:</strong> {[submittedOrder?.customer?.city || printData?.customer?.city, submittedOrder?.customer?.state || printData?.customer?.state].filter(Boolean).join(', ')}</div>
                                            )}
                                            {(submittedOrder?.customer?.address || printData?.customer?.address) && (
                                                <div><strong>Address:</strong> {submittedOrder?.customer?.address || printData?.customer?.address}</div>
                                            )}
                                        </div>
                                    </div>
                                </Col>

                                {/* Order Cost Summary Box */}
                                <Col md={6}>
                                    <div className='estimate-info-card p-3 rounded-3 h-100 border'>
                                        <h6 className='fw-bold text-dark d-flex align-items-center gap-2 mb-2 pb-1 border-bottom'>
                                            <span>💰 Order Summary</span>
                                        </h6>
                                        <div className='small lh-base'>
                                            <div className='d-flex justify-content-between mb-1'>
                                                <span className='text-muted'>Total Products:</span>
                                                <span className='fw-bold'>{submittedOrder?.totals?.totalProducts || totals.totalProducts} Items</span>
                                            </div>
                                            <div className='d-flex justify-content-between mb-1'>
                                                <span className='text-muted'>Total MRP:</span>
                                                <span className='text-decoration-line-through text-muted'>₹{Number(submittedOrder?.totals?.overallTotal || totals.overallTotal).toFixed(2)}</span>
                                            </div>
                                            <div className='d-flex justify-content-between mb-1 text-success'>
                                                <span>Festive Savings:</span>
                                                <span className='fw-bold'>- ₹{Number(submittedOrder?.totals?.discountedOverallTotal || totals.discountedOverallTotal).toFixed(2)}</span>
                                            </div>
                                            <div className='d-flex justify-content-between pt-2 border-top mt-1 align-items-center'>
                                                <span className='fw-bold text-dark'>Payable Amount:</span>
                                                <span className='fw-bolder text-success fs-5'>
                                                    ₹{Number(submittedOrder?.totals?.discountRate || totals.discountRate).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            {/* Company Contact Pill */}
                            <div className='estimate-store-info p-2 px-3 rounded-3 bg-light border text-center small text-muted'>
                                <span>📍 {companydata.company_name} — {companydata.address}</span>
                                {companydata.phone && <span className='ms-2'>| 📞 {companydata.phone}</span>}
                            </div>
                        </Modal.Body>
                        <Modal.Footer className='d-flex justify-content-between flex-wrap gap-2 p-3 bg-light border-top'>
                            <div>
                                <button 
                                    type='button' 
                                    className='btn btn-outline-secondary px-3 py-2 rounded-pill fw-bold small'
                                    onClick={closeModal}
                                >
                                    Done / Place Another Order
                                </button>
                            </div>
                            <div>
                                {printData && (Array.isArray(printData) ? printData.length > 0 : Object.keys(printData).length > 0) ? (
                                    <PDFDownloadLink
                                        document={<Bill data={printData} />}
                                        fileName={`Estimate_${printData?.enq || 'Quote'}.pdf`}
                                        style={{ textDecoration: 'none' }}
                                    >
                                        {({ loading }) => (
                                            <button
                                                type='button'
                                                className='btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-bold shadow-sm'
                                                disabled={loading}
                                                style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', border: 'none' }}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                                                        <span>Generating PDF...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaDownload size={15} />
                                                        <span>Download Estimate PDF</span>
                                                    </>
                                                )}
                                            </button>
                                        )}
                                    </PDFDownloadLink>
                                ) : (
                                    <button className='btn btn-secondary px-4 py-2 rounded-pill' disabled>
                                        Preparing PDF...
                                    </button>
                                )}
                            </div>
                        </Modal.Footer>
                    </Modal>
                </>
            </>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>

    )
}

export default CardFour